import React from 'react';

import './SettingsListItem.scss';

const SettingsListSpacer = () => <div styleName="spacer" />;

export default SettingsListSpacer;